<template>
    <!--欢迎页面-->
    <div class="welcome_login" ref="welcome">
        <img :src="$UIConfig.loginSucGif" alt v-if="loginAnimation" />
    </div>
</template>

<script>
export default {
    data(){
        return {
            loginAnimation: false
        }
    },
    methods: {
        transformLogin(){
            this.$refs.welcome.style.transform = 'scale(1, 1)';
        }
    }
}
</script>

<style lang="scss" scoped>
.welcome_login {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1000;
    text-align: center;
    line-height: 800px;
    transform: scale(0, 0);
    transition: all 0.5s linear;
    background: url('../images/welcome_login.png') center center no-repeat;
    background-size: 100% 100%;
}
</style>